module.exports = __webpack_public_path__ + "img/02_content_02.fb6e8aed.png";